import React from 'react';

/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';
import { defineMessages, FormattedMessage } from 'react-intl';

import { gridSize } from '@atlaskit/theme';

import { Repository } from 'src/components/types';
import urls from 'src/urls/source';

const messages = defineMessages({
  binaryFile: {
    id: 'frontbucket.repository.source.file.isBinary',
    description: 'Message to display in place of viewing a binary file',
    defaultMessage: `We can't display binary files.`,
  },
  lfsFile: {
    id: 'frontbucket.repository.source.file.isLfs',
    description: 'Message to display in place of viewing a binary Git LFS file',
    defaultMessage: `We can't display this Git LFS file.`,
  },
  viewRaw: {
    id: 'frontbucket.repository.source.file.viewRaw',
    description: 'Link to download the raw contents of a binary file',
    defaultMessage: 'Download file',
  },
});

const BinaryWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: ${gridSize() * 4}px;
`;

type Props = {
  repository: Repository;
  hash: string;
  path: string;
  isLfs?: boolean;
};

export default class BinaryFile extends React.Component<Props> {
  render() {
    const { repository, hash, path, isLfs = false } = this.props;
    return (
      <BinaryWrapper>
        <p>
          {isLfs ? (
            <FormattedMessage {...messages.lfsFile} />
          ) : (
            <FormattedMessage {...messages.binaryFile} />
          )}
        </p>
        <p>
          <a href={urls.ui.raw(repository.full_name, hash, path)}>
            <FormattedMessage {...messages.viewRaw} />
          </a>
        </p>
      </BinaryWrapper>
    );
  }
}
